var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14912 0.334539C9.51337 -0.0036481 10.0436 -0.0946353 10.4992 0.103827C10.955 0.302552 11.25 0.752902 11.25 1.25006V15.625C11.25 16.1223 10.955 16.5725 10.4992 16.7713C10.0436 16.9698 9.51337 16.8788 9.14912 16.5406L5.13427 12.8125H2.5C1.11929 12.8125 0 11.6933 0 10.3125V6.56251C0 5.18185 1.11929 4.06256 2.5 4.06256H5.13427L9.14912 0.334539ZM21.3037 4.11628C21.7919 3.62816 22.5831 3.62816 23.0713 4.11628C23.5594 4.60443 23.5594 5.39573 23.0713 5.88385L20.5176 8.43751L23.0713 10.9913C23.5594 11.4794 23.5594 12.2708 23.0713 12.7589C22.5831 13.247 21.7919 13.2469 21.3037 12.7589L18.75 10.2051L16.1962 12.7589C15.7081 13.247 14.9169 13.2469 14.4288 12.7589C13.9406 12.2706 13.9406 11.4794 14.4288 10.9913L16.9824 8.43751L14.4288 5.88385C13.9406 5.39569 13.9406 4.60441 14.4288 4.11628C14.9169 3.62816 15.7081 3.62816 16.1962 4.11628L18.75 6.67001L21.3037 4.11628Z",
    fill: "#8E092E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute-icon.e473c4bc3fe900329517f4c09bd80493.svg";
export { ForwardRef as ReactComponent };